import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

/**
 * Composant Recaptcha avec la configuration requise
 * @param children
 * @constructor
 */
export function CustomGoogleReCaptchaProvider({ children }: any) {
    return (
        <GoogleReCaptchaProvider
            reCaptchaKey="6LfxCsIlAAAAABv38kiIykTXe5hcgaJLTAHJCaqi"
            language="fr"
            useEnterprise={true}
        >
            {children}
        </GoogleReCaptchaProvider>
    );
}
